export default __webpack_public_path__ + "static/media/PUNKS-SHIRT-FRONT.d87b1c2f.png";